
import { Component, Vue } from 'nuxt-property-decorator'
import BPSection from './snippets/BPSection.vue'
import GoogleRatingLite from '~/components/widgets/GoogleRatingLite.vue'

import IconFacebook from '~/assets/icons/socials/icon-facebook.svg?inline'
import IconX from '~/assets/icons/socials/icon-x.svg?inline'
import IconInstagram from '~/assets/icons/socials/icon-instagram.svg?inline'
import IconLinkedin from '~/assets/icons/socials/icon-linkedin.svg?inline'

import IconWA from '~/assets/icons/icon-wa.svg?inline'

@Component({
  components: {
    BPSection,
    GoogleRatingLite,
    IconFacebook,
    IconX,
    IconInstagram,
    IconLinkedin,
    IconWA,
  },
})
export default class BSFooter extends Vue {
  readonly waContactNumber = this.$config.WA_WIDGET_NUMBER
}
